import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import type { Experience } from '@/features/experience-shell/types.ts'
import {
	type HttpUpdateCategorySubCategoryOptions,
	httpUpdateCategorySubCategory
} from '@/features/experience-vetting/http/experience-vetting.http.ts'
import { errorHandler } from '@/helpers/utils'
import { QUERY_KEYS } from '@/query-client'

export const useUpdateCategorySubCategory = ({
	experienceId,
	options
}: {
	experienceId: number
	options?: Omit<
		UseMutationOptions<
			Experience,
			unknown,
			HttpUpdateCategorySubCategoryOptions['payload']
		>,
		'mutationFn'
	>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (payload) =>
			httpUpdateCategorySubCategory({
				urlParams: { experienceId },
				payload,
				params: { responseType: 'extended' }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE_VETTING, experienceId]
			})
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE_VETTING, experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		},
		onError: (error, variables, onMutateResult, context) => {
			options?.onError?.(error, variables, onMutateResult, context)
			errorHandler(error)
		}
	})
}
